/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-curly-newline */
/* eslint-disable class-methods-use-this */
/* eslint-disable jsx-a11y/media-has-caption */
/* global fetch */

import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import videojs from 'video.js';
// import videojshotkeys from "videojs-hotkeys";   // adds keyboard shortcuts for video player control

import playlistIcon from './assets/DropdownArrow.svg';
import handleCharacterEncoding from '../../handleCharacterEncoding';
import mediathekConfigFile from '../../mediathek_config.json';
import './MediaPlayer.css';
import './videojs.css';
import '../Projectpage/VideoProjectPage/VideoProjectPage.css';

require('@silvermine/videojs-quality-selector')(videojs);

function MediaPlayer(props) {
  const {
    projectId,
    projectMediaData,
    viewportWidth,
  } = props;

  // STATES
  const [currentPlaylistIndex, setCurrentPlaylistIndex] = useState(0);
  const [moreThanOneVideo, setMoreThanOneVideo] = useState(false);
  const [showPlaylist, setShowPlaylist] = useState(true);
  const [playerActive, setPlayerActive] = useState(true);
  const [playerPaused, setPlayerPaused] = useState(true);
  // Array of strings with titles of videos in playlist
  const [playlistArray, setPlaylistArray] = useState([]);
  // Arrays of strings with human-friednly formatted durations of videos in playlist
  const [durationArray, setDurationArray] = useState([]);
  const [videoOptions, setVideoOptions] = useState({
    autoplay: false,
    playbackRates: [0.5, 1, 1.25, 1.5, 2],
    controlBar: {
      children: [
        'playToggle',
        'currentTimeDisplay',
        'progressControl',
        'durationDisplay',
        'volumePanel',
        /* 'qualitySelector', */ // Disabled because 2024, we always stream on highest resolution. 2024-10-07. wiest.
        'fullscreenToggle',
      ],
    },
    controls: true,
    html5: {
      vhs: {
        overrideNative: true,
      },
      nativeAudioTracks: false,
      nativeVideoTracks: false,
    },
  });
  const playerRef = useRef(null);

  const BREAKPOINT_MOBILE = 768;

  // FUNCTIONS
  function formatDuration(duration) {
    // Hours, minutes and seconds
    const hrs = Math.floor(duration / 3600);
    const mins = Math.floor((duration % 3600) / 60);
    const secs = Math.floor(duration % 60);

    // Output like "1:01" or "4:03:59" or "123:03:59"
    let ret = '';

    if (hrs > 0) {
      ret += `${hrs}:${mins < 10 ? '0' : ''}`;
    }

    ret += `${mins}:${secs < 10 ? '0' : ''}`;
    ret += `${secs}`;
    return ret;
  }

  function generatePlaylist() {
    const playlistTitleArray = [];
    const playListDurationArray = [];
    projectMediaData.forEach((medium) => {
      playlistTitleArray.push(medium.titel);
      playListDurationArray.push(formatDuration(medium.dauer));
    });
    setPlaylistArray(playlistTitleArray);
    setDurationArray(playListDurationArray);
  }

  async function trackClick(index) {
    if (mediathekConfigFile.enableStatistics) {
      try {
        const mediaId = projectMediaData[index].media_ID;
        if (typeof mediaId !== 'undefined' && mediaId !== null) {
          fetch(`https://hdm-stuttgart.de/mediathek/zaehle_video_nutzung?projekt_media_ID=${mediaId}`).then();
        }
      } catch (error) {
        console.error('Fetch für Statistik fehlgeschlagen.');
      }
    }
  }

  function handlePlaylistClick(index) {
    setCurrentPlaylistIndex(index);
  }

  function togglePlaylist() {
    if (showPlaylist) {
      setShowPlaylist(false);
    } else {
      setShowPlaylist(true);
    }
  }

  // Custom Button Component
  const Button = videojs.getComponent('Button');

  class ToggleCaptionsButton extends Button {
    constructor(player, options) {
      super(player, options);
      this.addClass('vjs-mycaptions-button');
      this.controlText('Untertitel ein/aus');
    }

    handleClick() {
      const player = this.player();
      const tracks = player.textTracks();
      for (let i = 0; i < tracks.length; i++) {
        if (tracks[i].kind === 'captions') {
          if (tracks[i].mode === 'showing') {
            tracks[i].mode = 'disabled';
            this.toggleClass('vjs-mycaptions-button-on');
          } else {
            tracks[i].mode = 'showing';
            this.toggleClass('vjs-mycaptions-button-on');
          }
        }
      }
    }
  }

  videojs.registerComponent('ToggleCaptionsButton', ToggleCaptionsButton);

  // EFFECTS
  useEffect(() => {
    generatePlaylist();
    setMoreThanOneVideo((projectMediaData.length > 1));
  }, [projectMediaData]);

  useEffect(() => {
    if (projectMediaData) {
      if (videojs.getPlayer(playerRef.current) == null) {
        videojs(playerRef.current, videoOptions, () => {
          const player = videojs.getPlayer(playerRef.current);
          if (player) {
            player.on('ready', () => {
              // Nothing to do here yet.
            });
            player.on('useractive', () => {
              if (!playerPaused) {
                setPlayerActive(true);
              }
            });
            player.on('userinactive', () => {
              if (!playerPaused) {
                setPlayerActive(false);
              }
            });
            player.on('pause', () => {
              setPlayerPaused(true);
            });
            player.on('play', () => {
              setPlayerPaused(false);
            });
          }
        });
      }

      if (videojs.getPlayer(playerRef.current) != null) {
        const player = videojs.getPlayer(playerRef.current);
        player.poster(`${process.env.REACT_APP_MEDIAFILES}/${projectId}/medianight_web/klein.jpg`);
        player.src(projectMediaData[currentPlaylistIndex].sources);

        // Remove existing VTT track and button from previous video
        player.removeRemoteTextTrack();
        player.controlBar.removeChild('ToggleCaptionsButton');

        // Add new VTT track and button, if available
        if (projectMediaData[currentPlaylistIndex].vtt) {
          player.addRemoteTextTrack({
            kind: 'captions',
            label: "Deutsch",
            src: `${projectMediaData[currentPlaylistIndex].vtt}`,
            default: false,
          }, false);
          player.controlBar.addChild('ToggleCaptionsButton', {}, player.controlBar.children().length - 1);
        }
      }
    }
  }, [projectMediaData, currentPlaylistIndex]);

  // RENDER

  let playerClass = '';
  if (moreThanOneVideo) {
    playerClass = (viewportWidth > BREAKPOINT_MOBILE) ? 'content-wrapper' : 'content-wrapper-mobile';
  } else {
    playerClass = (viewportWidth > BREAKPOINT_MOBILE) ? 'content-wrapper-without-playlist' : 'content-wrapper-mobile';
  }

  return (
    <div className={playerClass}>
      <div
        className={(viewportWidth > BREAKPOINT_MOBILE) ? 'video-player-wrapper' : 'video-player-wrapper-mobile'}
        style={{
          width: (moreThanOneVideo && (viewportWidth > BREAKPOINT_MOBILE)) ? '80%' : '100%',
        }}
      >
        <div data-vjs-player>
          <video
            preload="auto"
            data-setup='{"aspectRatio": "16:9"}'
            className="video-js"
            ref={playerRef}
          />

          {(moreThanOneVideo && (viewportWidth > BREAKPOINT_MOBILE)) ? (
            <div
              style={
                playerActive
                  ? {
                    visibility: 'visible',
                    transition: '0.5s ease',
                    opacity: '1',
                  }
                  : {
                    visibility: 'hidden',
                    transition: '0.5s ease',
                    opacity: '0',
                  }
              }
            >
              <div
                className="playlist-icon-wrapper"
                style={
                  showPlaylist
                    ? {
                      right: '17%',
                    }
                    : {
                      right: '0%',
                    }
                }
                onClick={() => togglePlaylist()}
              >
                <img
                  className="playlist-icon"
                  src={playlistIcon}
                  width={100}
                  alt="Zur Playlist hinzufügen"
                  style={
                    showPlaylist
                      ? {
                        transform: 'rotate(90deg)',
                      }
                      : {
                        transform: 'rotate(-90deg)',
                      }
                  }
                />
              </div>
            </div>
          ) : null}
          {/* playlist */}
          {(moreThanOneVideo && (viewportWidth > BREAKPOINT_MOBILE)) ? (
            <div
              style={
                playerActive
                  ? {
                    visibility: 'visible',
                    transition: '0.5s ease',
                    opacity: '1',
                  }
                  : {
                    visibility: 'hidden',
                    transition: '0.5s ease',
                    opacity: '0',
                  }
              }
            >
              <div
                className="playlist-wrapper"
                style={
                  showPlaylist
                    ? {
                      transition: '0.5s ease',
                      right: '0',
                    }
                    : {
                      transition: '0.5s ease',
                      right: '-17%',
                    }
                }
              >
                {playlistArray.map((value, index) => (
                  <button
                    type="button"
                    className="playlist-content"
                    style={{
                      background: index === currentPlaylistIndex ? 'rgba(150, 150, 150, 0.3)' : null,
                    }}
                    key={value}
                    onClick={() => handlePlaylistClick(index)}
                  >
                    <div
                      className="playlist-content-name"
                      style={
                        index === currentPlaylistIndex
                          ? {
                            color: 'white',
                            transition: '2s ease',
                          }
                          : {
                            transition: '2s ease',
                          }
                      }
                    >
                      {handleCharacterEncoding(value)}
                    </div>
                    <div className="duration-container">
                      <p className="duration-text">{durationArray[index]}</p>
                    </div>
                  </button>
                ))}
              </div>
            </div>
          ) : null}
          {/* playlist */}
        </div>
      </div>

      {/* plalist mobil */}
      {(moreThanOneVideo && (viewportWidth < BREAKPOINT_MOBILE + 1)) ? (
        <div className="playlist-wrapper-mobil">
          {playlistArray.map((value, index) => (
            <button
              type="button"
              className="playlist-content"
              style={{
                background: index === currentPlaylistIndex ? 'rgba(150, 150, 150, 0.3)' : null,
              }}
              key={value}
              onClick={() => handlePlaylistClick(index)}
            >
              <div
                className="playlist-content-name"
                style={
                  index === currentPlaylistIndex
                    ? {
                      color: 'white',
                      transition: '2s ease',
                    }
                    : {
                      transition: '2s ease',
                    }
                }
              >
                {handleCharacterEncoding(value)}
              </div>
              <div className="duration-container-mobil">
                <p className="duration-text">{durationArray[index]}</p>
              </div>
            </button>
          ))}
        </div>
      ) : null}
      {/* playlist */}
    </div>
  );
}

export default MediaPlayer;

MediaPlayer.propTypes = {
  projectId: PropTypes.number.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  projectMediaData: PropTypes.array.isRequired,
  viewportWidth: PropTypes.number.isRequired,
};
